/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImportRowErrorStatus = {
    Duplicate: 'Duplicate',
    Warning: 'Warning',
    Failed: 'Failed',
    Corrected: 'Corrected',
    Resolved: 'Resolved',
    Skipped: 'Skipped'
} as const;
export type ImportRowErrorStatus = typeof ImportRowErrorStatus[keyof typeof ImportRowErrorStatus];


export function instanceOfImportRowErrorStatus(value: any): boolean {
    for (const key in ImportRowErrorStatus) {
        if (Object.prototype.hasOwnProperty.call(ImportRowErrorStatus, key)) {
            if (ImportRowErrorStatus[key as keyof typeof ImportRowErrorStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportRowErrorStatusFromJSON(json: any): ImportRowErrorStatus {
    return ImportRowErrorStatusFromJSONTyped(json, false);
}

export function ImportRowErrorStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportRowErrorStatus {
    return json as ImportRowErrorStatus;
}

export function ImportRowErrorStatusToJSON(value?: ImportRowErrorStatus | null): any {
    return value as any;
}

export function ImportRowErrorStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportRowErrorStatus {
    return value as ImportRowErrorStatus;
}

